import { render, staticRenderFns } from "./OrderShipmentCarrier.vue?vue&type=template&id=6c4a987e&"
import script from "./OrderShipmentCarrier.vue?vue&type=script&lang=ts&"
export * from "./OrderShipmentCarrier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports